import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../store/slices/authSlice';
import { useDashboardStats } from '../../hooks/useDashboardStats';

import { WelcomeSection } from '../../components/dashboard/WelcomeSection';
import { DashboardDateFilter, DateFilterType } from '../../components/dashboard/DashboardDateFilter';
import { StatsCards } from '../../components/dashboard/StatsCards';
import { QuickActions } from '../../components/dashboard/QuickActions';
import { RecentActivity } from '../../components/dashboard/RecentActivity';
import RevenueChart from '../../components/marketing/RevenueChart';
import PatientChart from '../../components/marketing/PatientChart';

const Dashboard: React.FC = () => {
  const currentUser = useSelector(selectCurrentUser);
  
  const [dateFilter, setDateFilter] = useState<DateFilterType>('today');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [applyTrigger, setApplyTrigger] = useState(0);

  const { clinicSettings, stats, isLoading } = useDashboardStats(dateFilter, startDate, endDate, applyTrigger);

  const handleApply = () => {
    setApplyTrigger(prev => prev + 1);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in-up">
      <WelcomeSection 
        currentUser={currentUser} 
        clinicSettings={clinicSettings} 
      />

      <DashboardDateFilter 
        filter={dateFilter}
        setFilter={setDateFilter}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        onApply={handleApply}
      />

      <StatsCards 
        stats={stats} 
        isLoading={isLoading} 
        dateFilter={dateFilter}
      />

      {!isLoading && stats.revenueTrends && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          <RevenueChart trends={stats.revenueTrends as any} title="Tren Omset Kasir (7 Hari)" />
          <PatientChart trends={stats.revenueTrends as any} title="Tren Kunjungan Pasien (7 Hari)" />
        </div>
      )}

      <QuickActions 
        userRole={currentUser?.role || ''} 
      />

      <RecentActivity activities={stats.recentActivities || []} />
    </div>
  );
};

export default Dashboard;